import {DashboardReportConfig} from "./@type"
import {timeReportingPresets} from "./time-reporting-presets"
import {generateUniqueId} from "../../core/gd/utils/misc/generate-unique-id"
import ReportProjectTimeReportByUser from "../../core/model2/report/reports/time-reports/project-time-report-by-user/project-time-report-by-user"
import ReportProjectTimeReportByDate from "../../core/model2/report/reports/time-reports/project-time-report-by-date/project-time-report-by-date"
import ReportTimeReportingSummary from "../../core/model2/report/reports/time-reports/time-reporting-summary/time-reporting-summary"

const reportSettings = (name: string) => ({
    id          : generateUniqueId(),
    name        : name,
    autoGenerate: false
})

export const timeReportingConfig: DashboardReportConfig[] = [
    {
        icon        : "isvg-time-by-project",
        name        : "Time reports",
        description : "Provides an overview of time reports, helping to track progress and evaluate performance.",
        subitems    : [
            { 
                icon         : "i5-project",                    
                name         : "By Project", 
                description  : "Analyze tracked time across projects.",        
                createReport : timeReportingPresets.byProject 
            },
            { 
                icon         : "i5-user",                       
                name         : "By User",    
                description  : "View time tracked by team members.",            
                createReport : timeReportingPresets.byUser 
            },
            { 
                icon         : "i5-calendar",                   
                name         : "By Date",    
                description  : "Time tracking grouped by date.",                
                createReport : timeReportingPresets.byDate 
            },
            { 
                icon         : "i5-settings-dashboard-billing", 
                name         : "Finance",    
                description  : "Financial time and cost overview.",             
                createReport : timeReportingPresets.finance 
            },
            { 
                icon         : "i5-settings",                   
                name         : "Custom",     
                description  : "Build reports with filters and columns.",       
                createReport : timeReportingPresets.custom 
            },
        ]
    },
    {
        icon        : "isvg-breakdown-reports",
        name        : "Breakdown reports",
        description : "View hours logged across projects, broken down by user or date.",
        subitems    : [
            {
                icon         : "i5-user",
                name         : ReportProjectTimeReportByUser.reportName,
                description  : "View hours logged by users for work items.",
                createReport : () => new ReportProjectTimeReportByUser(reportSettings(ReportProjectTimeReportByUser.reportName))
            },
            { 
                icon         : "i5-calendar", 
                name         : ReportProjectTimeReportByDate.reportName, 
                description  : "View hours logged by date in projects.", 
                createReport : () => new ReportProjectTimeReportByDate(reportSettings(ReportProjectTimeReportByDate.reportName)) 
            },
        ]
    },
    {
        icon        : "isvg-time-entries-2",
        name        : "Time Entries",
        description : "The Time Entries report shows time logged across tasks and projects.",
        subitems    : [
            {
                icon         : "i5-task-by-user",
                name         : "All time entries",
                description  : "All time reports by task, date, and user.",
                createReport : timeReportingPresets.allTimeEntries
            },
            { 
                icon         : "i5-user-assigned", 
                name         : "My time entries",               
                description  : "View your personal time reports only.",         
                createReport : timeReportingPresets.myReports 
            },
            { 
                icon         : "i5-todo1",         
                name         : "Pending approval",              
                description  : "View time reports that are awaiting approval.", 
                disabled     : true 
            },
        ]
    },
    {
        icon         : "isvg-time-reporting",
        name         : ReportTimeReportingSummary.reportName,
        description  : "Displays reported hours per user within a selected period, highlighting compliance with minimum reporting requirements.",
        createReport : () => new ReportTimeReportingSummary(reportSettings(ReportTimeReportingSummary.reportName))
    },
]
